/* global graphql */

import React from 'react';
import Section from '../components/Section';
import CTA from '../components/CTA';

// import aboutImage from '../../static/images/about.jpg';

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const siteImages = {};
    this.props.data.siteImages.edges.map((elem, index) => {
      siteImages[elem.node.name] = elem.node;
    });

    return (
      <div className="page">
        <h1>Home</h1>
        {/* <Section image={siteImages['about']} title="about the broomwagon">
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        </Section> */}
        <Section
          image={siteImages.event}
          title="Broomwagon coffee at your event"
          CTA={<CTA to="#contact" label="Get in touch!" />}
        >
          <p>
            If you want The Broomwagon with carefully roasted coffee and other drinks/snacks at your
            event. We offer personalised packages. It can be an event in Girona but also outside the
            city center. Get in touch with us to see if we can be at your sport/private/business
            event.
          </p>
        </Section>
        <Section
          image={siteImages.shop}
          title="The Broomwagon shop"
          CTA={<CTA to="/webshop/" label="Shop now" />}
        >
          <p>
            In our web shop you can find our own line of cycling kit, casual clothes and accessories
            designed in colaboration with Robert Gesink.
          </p>
        </Section>
        <Section
          image={siteImages.experience}
          title="Broomwagon Experiences"
          CTA={<CTA to="/experiences/" label="more info" />}
        >
          <p>
            Robert Gesink has been training in the Girona area for most of his career. Needles to
            say he knows all the nice roads, the perfect guide on the bike. Daisy knows the city and
            it's secret addresses for local delicacies inside out. The kids will dazzle you with
            their fluentness in 4 different languages. Together they make up quite the hosts and
            will give you the ultimate Girona experience!
          </p>
        </Section>
      </div>
    );
  }
}

export default IndexPage;

export const IndexPageQuery = graphql`
  query IndexPageQuery {
    siteImages: allFile(filter: { sourceInstanceName: { eq: "siteImages" } }) {
      edges {
        node {
          name
          childImageSharp {
            resolutions(width: 180, height: 180, quality: 75) {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js